import styled from 'styled-components';

export const StyledFormViewContainer = styled.div<{
  layout: 'horizontal' | 'vertical';
}>`
  display: flex;
  flex-direction: column;
  //   gap: 16px;
  background: #ffffff;
`;

export const StyledFormViewItem = styled.div<{
  layout: 'horizontal' | 'vertical';
}>`
  display: flex;
  flex-direction: ${({ layout }) =>
    layout === 'horizontal' ? 'row' : 'column'};
  align-items: 'flex-start';
  justify-content: ${({ layout }) =>
    layout === 'horizontal' ? 'space-between' : 'flex-start'};
  gap: ${({ layout }) => (layout === 'horizontal' ? '16px' : '4px')};
  padding: ${({ layout }) => (layout === 'horizontal' ? '12px 0' : '8px 0')};

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledFormViewLabel = styled.span<{
  layout: 'horizontal' | 'vertical';
}>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutral[400]};
  min-width: ${({ layout }) => (layout === 'horizontal' ? '200px' : 'auto')};
  flex-shrink: 0;
`;

export const StyledFormViewValue = styled.span<{
  layout: 'horizontal' | 'vertical';
}>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.neutral[700]};
  flex: 1;
  text-align: left;
  word-break: break-word;
`;

export const StyledFormViewValueHighlight = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 2px 8px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.palette.neutral[50]};
  border: 1px solid ${({ theme }) => theme.palette.neutral[100]};
`;
